/**
 * ClientReframe Component
 * Section 3: The Reframe - Execution needs infrastructure
 */

import React from 'react';
import { CheckCircle2 } from 'lucide-react';

export const ClientReframe: React.FC = () => {
  const scrollToForm = () => {
    const element = document.getElementById('execution-fit-form');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="bg-stone-50 py-20 md:py-32">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">

          {/* Headline */}
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-stone-900 mb-12 leading-tight">
            Execution needs infrastructure — not more follow-ups.
          </h2>

          {/* Content */}
          <div className="space-y-8 text-lg md:text-xl text-stone-700 leading-relaxed">

            <p>
              Alignment conversations are necessary.
            </p>
            <p className="text-stone-900 font-medium">
              They are not sufficient.
            </p>

            <p className="pt-4">
              Without a system to:
            </p>

            <ul className="space-y-3 ml-6">
              <li className="flex items-start">
                <span className="text-stone-400 mr-3">•</span>
                <span>Structure priorities</span>
              </li>
              <li className="flex items-start">
                <span className="text-stone-400 mr-3">•</span>
                <span>Track measurable outcomes</span>
              </li>
              <li className="flex items-start">
                <span className="text-stone-400 mr-3">•</span>
                <span>Maintain execution cadence</span>
              </li>
              <li className="flex items-start">
                <span className="text-stone-400 mr-3">•</span>
                <span>Make progress visible to leadership</span>
              </li>
            </ul>

            <p className="pt-4 text-stone-900 font-medium">
              Execution becomes fragile and dependent on people, not process.
            </p>

            {/* Value Prop Box */}
            <div className="bg-white border-2 border-stone-200 rounded-xl p-8 my-12">
              <p className="text-xl md:text-2xl text-stone-900 font-medium mb-6">
                OKR Hub is execution infrastructure consultants use to operationalize leadership intent — without replacing their methodology.
              </p>
            </div>

            <p className="text-stone-900 font-medium">
              You keep control of:
            </p>

            <ul className="space-y-3 ml-6">
              <li className="flex items-start">
                <CheckCircle2 className="w-6 h-6 text-stone-900 mr-3 flex-shrink-0 mt-0.5" />
                <span>The framework</span>
              </li>
              <li className="flex items-start">
                <CheckCircle2 className="w-6 h-6 text-stone-900 mr-3 flex-shrink-0 mt-0.5" />
                <span>The conversations</span>
              </li>
              <li className="flex items-start">
                <CheckCircle2 className="w-6 h-6 text-stone-900 mr-3 flex-shrink-0 mt-0.5" />
                <span>The client relationship</span>
              </li>
            </ul>

            <p className="pt-4 text-lg text-stone-900">
              OKR Hub ensures execution discipline survives after you step back.
            </p>

          </div>

          {/* CTA */}
          <div className="mt-12">
            <button
              onClick={scrollToForm}
              className="inline-flex items-center justify-center px-6 py-3 text-base font-medium text-stone-900 border-2 border-stone-300 rounded-lg hover:border-stone-900 hover:bg-white transition-all duration-300"
            >
              Understand how this fits into your engagements
            </button>
          </div>

        </div>
      </div>
    </section>
  );
};
